// src/toolkitServices/reportApi.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const cleanParams = (obj = {}) => {
  const out = {};
  for (const [k, v] of Object.entries(obj)) {
    if (v === undefined || v === null) continue;
    if (typeof v === "string" && v.trim() === "") continue;
    out[k] = v;
  }
  return out;
};

const reportApi = createApi({
  reducerPath: "reportApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASE_URL,
    credentials: "include",
  }),
  endpoints: (builder) => ({
    // ✅ Unlabelled daily/range report (counterId added)
    getUnlabelledDailyReport: builder.query({
      query: ({
        date,
        from,
        to,
        movement = true,
        branchId,
        counterId, // ✅ NEW
        categoryId,
        productId,
        designId,
        purityId,
        tz = "Asia/Kolkata",
      } = {}) => {
        const params = cleanParams({
          tz,
          movement,
          branchId,
          counterId, // ✅ NEW
          categoryId,
          productId,
          designId,
          purityId,
          ...(from && to ? { from, to } : {}),
          ...(!from && !to && date ? { date } : {}),
        });
        return { url: "/unlabelled-stock/report/daily", params };
      },
      keepUnusedDataFor: 60,
    }),

    // ✅ Labelled daily/range report (counterId + includeScrap forwarded)
    getLabelledDailyReport: builder.query({
      query: ({
        date,
        from,
        to,
        movement = true,
        includeScrap = true,
        branchId,
        counterId, // ✅ NEW
        categoryId,
        productId,
        designId,
        purityId,
        tz = "Asia/Kolkata",
      } = {}) => {
        const params = cleanParams({
          tz,
          movement,
          includeScrap,
          branchId,
          counterId, // ✅ NEW
          categoryId,
          productId,
          designId,
          purityId,
          ...(from && to ? { from, to } : {}),
          ...(!from && !to && date ? { date } : {}),
        });
        return { url: "/labelled-items/report/daily", params };
      },
      keepUnusedDataFor: 60,
    }),
  }),
});

export const { useGetUnlabelledDailyReportQuery, useGetLabelledDailyReportQuery } = reportApi;

export default reportApi;
